import { render, staticRenderFns } from "./myRequest.vue?vue&type=template&id=10d1ed84&scoped=true"
import script from "./myRequest.vue?vue&type=script&lang=js"
export * from "./myRequest.vue?vue&type=script&lang=js"
import style0 from "./myRequest.vue?vue&type=style&index=0&id=10d1ed84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d1ed84",
  null
  
)

export default component.exports